const { useState } = require('react');

const fileFormats = ['CSV', 'PDF'];

const fieldValidations = {
  name: (value) => value && value.length > 0,
  webhook: (value) => true,
  fileFormat: (value) =>
    value && fileFormats.find((format) => format === value),
  variables: (value) => value && value.length > 0,
  sessionId: (value) => value && value.length > 0,
  startDate: (value) => value && String(value) !== 'Invalid Date',
  endDate: (value) => value && String(value) !== 'Invalid Date',
};

export const useReportData = (initialData) => {
  const [reportData, setReportData] = useState(initialData || {});
  const [errors, setErrors] = useState([]);

  const changeReportData = (newReportData) => setReportData(newReportData);

  const onChangeFormField = (value, key) => {
    if (fieldValidations[key]) {
      const isValid = fieldValidations[key](value);

      const hasError = errors.indexOf(key);
      const newFormErrors = [...errors];
      if (hasError > -1) {
        if (isValid) {
          newFormErrors.splice(hasError, 1);
        }
      } else if (!isValid) {
        newFormErrors.push(key);
      }
      setErrors(newFormErrors);
    }

    const newReportData = { ...reportData, [key]: value };
    setReportData(newReportData);
  };

  const isDataValid = () => {
    const newFormErrors = [];
    Object.keys(reportData).forEach((key) => {
      if (fieldValidations[key] && !fieldValidations[key](reportData[key])) {
        newFormErrors.push(key);
      }
    });

    setErrors(newFormErrors);

    return newFormErrors.length === 0;
  };

  return {
    reportData,
    errors,
    changeReportData,
    isDataValid,
    onChangeFormField,
  };
};
